// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IZ_PxMcwWWWsbB4uQ8xd {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
  margin-bottom: 16px;
  margin-top: 80px;
  max-width: 1440px;
}

.NWfYKJc6jHaUDLT9ExJJ {
  display: inline-block;
  width: 100%;
}

.ndjAjgZ7lyFwAqTxS2rj {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
  font-weight: bold;
}

.ds3vyuCHlGA_OojpDH6X {
  white-space: pre-line;
  font-size: 18px;
}

.eChebwquDhFbGx3t5MTz {
  width: 40%;
  max-width: 720px;
}

.IZ_PxMcwWWWsbB4uQ8xd .pCKDrQbTKhgSXohCMx6W {
  white-space: pre-line;
}

.IZ_PxMcwWWWsbB4uQ8xd ._FwNORGj5N0wGgHqHI7i {
  width: 5%;
  height: 5px;
  float: left;
  display: block;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  border-radius: 10px;
}


@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .IZ_PxMcwWWWsbB4uQ8xd {
    width: 100%;
    margin-top: 30px;
    flex-direction: column;
  }
  
  .IZ_PxMcwWWWsbB4uQ8xd ._FwNORGj5N0wGgHqHI7i {
    width: 20%;
  }

  .eChebwquDhFbGx3t5MTz {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Helper/Helper.module.css"],"names":[],"mappings":"AAMA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mDAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,cAAc;EACd,8DAA8B;EAC9B,8DAA8B;EAC9B,mBAAmB;AACrB;;;AAGA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-text, color-purple from colors;\n\n.helperContainer {\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: auto;\n  margin-bottom: 16px;\n  margin-top: 80px;\n  max-width: 1440px;\n}\n\n.fullWidth {\n  display: inline-block;\n  width: 100%;\n}\n\n.helperTitle {\n  color: color-text;\n  font-weight: bold;\n}\n\n.helperSubTitle {\n  white-space: pre-line;\n  font-size: 18px;\n}\n\n.helperText {\n  width: 40%;\n  max-width: 720px;\n}\n\n.helperContainer .title {\n  white-space: pre-line;\n}\n\n.helperContainer .hr {\n  width: 5%;\n  height: 5px;\n  float: left;\n  display: block;\n  border: 1px solid color-purple;\n  background-color: color-purple;\n  border-radius: 10px;\n}\n\n\n@media screen and (max-width: tablet-l) {\n  .helperContainer {\n    width: 100%;\n    margin-top: 30px;\n    flex-direction: column;\n  }\n  \n  .helperContainer .hr {\n    width: 20%;\n  }\n\n  .helperText {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"helperContainer": `IZ_PxMcwWWWsbB4uQ8xd`,
	"fullWidth": `NWfYKJc6jHaUDLT9ExJJ`,
	"helperTitle": `ndjAjgZ7lyFwAqTxS2rj`,
	"helperSubTitle": `ds3vyuCHlGA_OojpDH6X`,
	"helperText": `eChebwquDhFbGx3t5MTz`,
	"title": `pCKDrQbTKhgSXohCMx6W`,
	"hr": `_FwNORGj5N0wGgHqHI7i`
};
export default ___CSS_LOADER_EXPORT___;
